function initAccountDropdown() {
  const rewardsButton = document.querySelector('.rewards-button');
  const accountDropdownDialog = document.querySelector('.account-dropdown');
  const accountDropdownTrigger = document.querySelector('.account-dropdown-trigger');
  const accountDropdownCloseTrigger = document.querySelector('.account-dropdown__close');

  initEvents(accountDropdownTrigger, accountDropdownCloseTrigger, accountDropdownDialog, rewardsButton);
}

function initEvents(modalOpenButton, modalCloseButton, modalElement, rewardsButton) {
  if(rewardsButton) {
    rewardsButton.addEventListener('click', () => {
      // Oude code (popup)
      /*
      if (gw) {
        gw.sdk.rewards.methods.openRewardsPopup();
        closeModal(modalElement);
      }
      */
  
      // New code (linken to rewards page)
      window.location.href = '/pages/rewards';
    });
  }

  modalOpenButton.addEventListener('click', (e) => {
    e.preventDefault();
    openModal(modalElement);
  });

  modalCloseButton.addEventListener('click', (e) => {
    e.preventDefault();
    closeModal(modalElement);
  });

  modalElement.addEventListener('click', (e) => {
    if(e.target !== modalElement) return;
    closeModal(modalElement);
  });
}

function openModal(modalElement) {
  modalElement.showModal()
}

function closeModal(modalElement) {
  modalElement.close();
}


window.onload = initAccountDropdown();
